import "./Orders.css";
import "./ResponsiveOrders.css";
import useOrders from "./useOrders";
import MyOrders from "./MyOrders/MyOrders.js";
import DoneOrders from "./DoneOrders/DoneOrders.js";

import { NavLink, Route, Routes } from "react-router-dom";
import { getTranslatedText as translate } from "../Localization/Translation";

function Orders() {
  const { locale, mainTabClick, clickHamburger } = useOrders();

  return (
    <div className="main-component">
      <div className="hamburger-third-level-container">
        <div className="hamburger-third-level" onClick={clickHamburger}>
          <span className="bar-third-level"></span>
          <span className="bar-third-level"></span>
          <span className="bar-third-level"></span>
        </div>
      </div>
      <div className="main-navbar main-navbar-orders" dir="auto">
        <NavLink
          to="/Navbar/Orders/MyOrders"
          className="password-orders-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".password-orders-tab")}
        >
          <span>{translate("my-orders-nav", locale)}</span>
        </NavLink>
        <NavLink
          to="/Navbar/Orders/DoneOrders"
          className="location-orders-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".location-orders-tab")}
        >
          <span>{translate("done-orders-nav", locale)}</span>
        </NavLink>
      </div>

      <Routes>
        <Route path="MyOrders" element={<MyOrders />} />
        <Route path="DoneOrders" element={<DoneOrders />} />
      </Routes>
    </div>
  );
}

export default Orders;
